import type { FeatureEvents, ScreenEvent, UIEvent } from '../new-analytics-types';
import { Action, ActionSubject } from '../new-analytics-types';

type ScreenKeys =
  | 'teamSiteAssignmentPageUnassignedTabScreen'
  | 'teamSiteAssignmentPageAssignedTabScreen'
  | 'teamSiteAssignmentPageReviewAssignmentsScreen';
type UiKeys =
  | 'reviewAssignmentsButton'
  | 'whoCanAssignTeamsToSitesSelected'
  | 'confirmAssignmentsButton'
  | 'reviewAssignmentsBackButton'
  | 'teamSiteAssignmentSiteSelected'
  | 'teamSiteAssignmentBulkSelectedSites';

export const teamSiteAssignmentEvents: FeatureEvents<ScreenKeys, UiKeys, string, string> = {
  confluenceSpec: 'https://hello.atlassian.net/wiki/spaces/PTC/pages/5705290313/Mixed-scope+Teams+-+What+should+we+be+measuring',
  screen: {
    teamSiteAssignmentPageUnassignedTabScreen: (): ScreenEvent => ({
      data: {
        name: 'teamSiteAssignmentPageUnassignedTab',
      },
      dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/88490',
    }),
    teamSiteAssignmentPageAssignedTabScreen: (): ScreenEvent => ({
      data: {
        name: 'teamSiteAssignmentPageAssignedTab',
      },
      dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/88493',
    }),
    teamSiteAssignmentPageReviewAssignmentsScreen: (): ScreenEvent => ({
      data: {
        name: 'teamSiteAssignmentPageReviewAssignments',
      },
      dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/88503',
    }),
  },
  ui: {
    whoCanAssignTeamsToSitesSelected: (attributes: { permission: string }): UIEvent => ({
      data: {
        action: Action.Selected,
        actionSubject: ActionSubject.DropdownItem,
        actionSubjectId: 'whoCanAssignTeamsToSitesSelected',
        source: 'teamSiteAssignmentPage',
        attributes: {
          permission: attributes.permission,
        },
      },
      dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/88498',
    }),
    reviewAssignmentsButton: (): UIEvent => ({
      data: {
        action: Action.Clicked,
        actionSubject: ActionSubject.Button,
        actionSubjectId: 'reviewAssignmentsButton',
        source: 'teamSiteAssignmentPage',
      },
      dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/88495',
    }),
    confirmAssignmentsButton: (attributes: { success: boolean; error?: string }): UIEvent => ({
      data: {
        action: Action.Clicked,
        actionSubject: ActionSubject.Button,
        actionSubjectId: 'confirmAssignmentsButton',
        source: 'teamSiteAssignmentPage',
        attributes: {
          success: attributes.success,
          error: attributes.error,
        },
      },
      dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/88505',
    }),
    reviewAssignmentsBackButton: (): UIEvent => ({
      data: {
        action: Action.Clicked,
        actionSubject: ActionSubject.Button,
        actionSubjectId: 'reviewAssignmentsBackButton',
        source: 'teamSiteAssignmentPage',
      },
      dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/88504',
    }),
    teamSiteAssignmentSiteSelected: (attributes: { isSuggestedSite: boolean }): UIEvent => ({
      data: {
        action: Action.Selected,
        actionSubject: ActionSubject.SelectItem,
        actionSubjectId: 'teamSiteAssignmentSiteSelected',
        source: 'teamSiteAssignmentPage',
        attributes: {
          isSuggestedSite: attributes.isSuggestedSite,
        },
      },
      dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/88501',
    }),
    teamSiteAssignmentBulkSelectedSites: (): UIEvent => ({
      data: {
        action: Action.Selected,
        actionSubject: ActionSubject.SelectItem,
        actionSubjectId: 'teamSiteAssignmentBulkSelectedSites',
        source: 'teamSiteAssignmentPage',
      },
      dataPortalLink: 'https://data-portal.internal.atlassian.com/analytics/registry/88502',
    }),
  },
  track: {},
  operational: {},
};
